var mailcheck = require('mailcheck');
var template = require('../js/template');

function checkEmailSpelling(e){
  var input = e.target
  var badDomains = []
  if(input && input.dataset.didYouMean == 'check'){
    // the arrays domains, secondLevelDomains and topLevelDomains are made up of the top 100 we know are good domains
    mailcheck.run({
      domains: ['gmail.com','yahoo.com','hotmail.com','outlook.com','icloud.com','qq.com','aol.com','yahoo.fr','mail.ru','hotmail.fr','web.de','live.com','nauta.cu','hotmail.co.uk','ymail.com','gmx.de','yahoo.co.uk','msn.com','163.com','hotmail.es','outlook.fr','yahoo.co.id','protonmail.com','yahoo.de','live.fr','yandex.ru','t-online.de','naver.com','yahoo.com.br','yahoo.es','outlook.es','comcast.net','wp.pl','googlemail.com','rocketmail.com','bk.ru','hotmail.de','libero.it','yandex.com','yahoo.co.jp','yahoo.com.ph','ukr.net','yahoo.ca','orange.fr','gmx.net','rediffmail.com','live.co.uk','gmx.at','me.com','yahoo.co.in','hotmail.it','yahoo.com.au','sbcglobal.net','yahoo.it','wanadoo.fr','att.net','126.com','seznam.cz','gmx.com','live.nl','o2.pl','yahoo.com.mx','interia.pl','outlook.de','yahoo.com.vn','abv.bg','inbox.ru','yandex.ua','bluewin.ch','list.ru','rambler.ru','bol.com.br','live.com.mx','freenet.de','yahoo.in','verizon.net','yahoo.gr','hanmail.net'], // replaces existing domains
      secondLevelDomains: [], // replaces existing SLDs
      topLevelDomains: [], // replaces existing TLDs
      email: input.value,
      suggested: function(suggestion) {
        //found a suggestion, so add markup below email input field
        var link = document.querySelector('[data-suggestion-full]')
        if(link){
          link.parentElement.remove()
        }
        var message = template.populate('did-you-mean-tpl', {
          text: ['[data-suggestion-full]', 'innerText']
        }, {
          text: suggestion.full
        });
        input.parentElement.append(message)
        bindClick(input,'[data-suggestion-full]')
        //let form validation know this is valid
        triggerEvent(input, 'valid')
      },
      empty: function() {
        //if there is a suggestion already, remove it.
        //As user my have entered an email that the mailcheck thinks is ok
        var message = document.querySelector('[data-suggestion-full]')
        if(message){
          message.parentElement.remove()
        }
        //split the input string
        var inputBadDomain = input.value.split('@')
        // now check if the domain is in the badDomains array
        if(badDomains.includes(inputBadDomain[1])){
          //let form validation know this is invalid
          triggerEvent(input, 'invalid')
        }
      }
    });
  }
}

function triggerEvent(input, eventType){
  input.setCustomValidity('')
  var evt = new Event(eventType, {"bubbles":true, "cancelable":false})
  input.dispatchEvent(evt)
}

function bindClick(input,target){
  var link = document.querySelector(target)
  if(link){
    link.addEventListener('click', function(){
      input.value = link.innerText
      link.parentElement.remove()
    })
  }
}

document.addEventListener('focusout',checkEmailSpelling)